// kk TODO: rename this file, it no longer has anything in common with local storage
import { GraphConverter } from "@store/services/converter/graphConverter"
import { GraphNodeEdgeData } from "@store/services/converter/types"
import { base64ToBlob, blobToBase64 } from "base64-blob"
import Dexie, { EntityTable } from "dexie"
import { getDefaultStore } from "jotai"
import { isModifiedAtom } from "@features/graph/state/graphAtoms"
import { graphConverterUnpackZip } from "@store/services/converter/unpackZip"

type GraphTable = {
  graphKey: string
  base64: string
  modified: boolean
}

export const LOCAL_SCENARIO_HASH = "scenario"

const db = new Dexie("pgm_app_db") as Dexie & {
  graphs: EntityTable<
    GraphTable,
    "graphKey" // primary key
  >
}

db.version(1).stores({
  graphs: "graphKey, base64, modified",
})

export const graphGetIndexedDb = async (
  key: string,
  s3Hash = LOCAL_SCENARIO_HASH,
): Promise<GraphTable | undefined> => {
  return db.graphs.where("graphKey").equals(`${key}#${s3Hash}`).first()
}

export const getUnpackedGraph = async (key: string, s3Hash = LOCAL_SCENARIO_HASH) => {
  const nodeEdgeData = await graphGetIndexedDb(key, s3Hash)
  if (!nodeEdgeData) return

  const blob = await base64ToBlob(nodeEdgeData.base64)
  return graphConverterUnpackZip(blob)
}

export const graphGetIndexedDbData = async (
  key: string,
  s3Hash = LOCAL_SCENARIO_HASH,
): Promise<{ data: GraphNodeEdgeData; modified: boolean } | undefined> => {
  const nodeEdgeData = await graphGetIndexedDb(key, s3Hash)
  if (!nodeEdgeData) {
    return
  }
  const blob = await base64ToBlob(nodeEdgeData.base64)
  const unpacked = await graphConverterUnpackZip(blob)

  return { data: GraphConverter.convertToReactFlow(unpacked), modified: nodeEdgeData.modified }
}

export const graphSaveIndexedDb = async (
  graphKey: string,
  graphData: GraphNodeEdgeData,
  s3Hash: string = LOCAL_SCENARIO_HASH,
  modified: boolean = false,
) => {
  const blob = await GraphConverter.packZip(GraphConverter.convertToZipStructure(graphData))
  const base64 = await blobToBase64(blob)

  await saveGraphBase64ToIndexedDb(graphKey, base64, s3Hash, modified)
}

export const saveLocalGraph = async (graphKey: string, s3Hash: string) => {
  const nodeEdgeData = await graphGetIndexedDb(graphKey, s3Hash)
  if (!nodeEdgeData) {
    return
  }
  await saveGraphBase64ToIndexedDb(graphKey, nodeEdgeData.base64)
}

export const saveGraphBase64ToIndexedDb = async (
  graphKey: string,
  base64: string,
  s3Hash = LOCAL_SCENARIO_HASH,
  modified: boolean = false,
) => {
  if (!base64 || base64.length === 0) {
    return
  }

  getDefaultStore().set(isModifiedAtom, modified)
  await db.graphs.put({ graphKey: `${graphKey}#${s3Hash}`, base64, modified })
}

export const deleteGraphFromIndexedDb = (key: string, s3Hash = LOCAL_SCENARIO_HASH) =>
  db.graphs.delete(`${key}#${s3Hash}`)
